import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, FormControl, Grid } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import axios from "axios";
import { facilityData } from '../Store';
import { useAuth } from './../contexts/AuthContext';
import { apiURL } from './../apis/ApiConfig';
import { usePost } from './../apis/ApiRequests';
import CustomOutlinedInput from '../components/input/CustomOutlinedInput';
import Header from '../components/Header';

const useWindowSize = () => {
    const [size, setSize] = useState([window.innerWidth, window.innerHeight]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerWidth, window.innerHeight]);
      };
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
    return size;
}
const Mobile = () => {

    const { authInfo,  setAuthInfo  } = useAuth();
    const [ userId,    setUserId    ] = useState('');
    const [ password,  setPassword  ] = useState('');
    const navigate = useNavigate();
    
    //===============================================
    // initialize
    //===============================================
	//-----------------------------------------------
	// Storeデータの取得
	//-----------------------------------------------
    const facilityCode = facilityData.facilityCode;
    const facilityName = facilityData.facilityName;

	//-----------------------------------------------
    // initialize - AXIOSの初期設定
	//-----------------------------------------------
    axios.defaults.baseURL = apiURL;

    //===============================================
    // API
    //===============================================
	//-----------------------------------------------
    // API - ログイン
	//-----------------------------------------------
    const { response : loginPostResponse, post : loginPostData } = usePost();
    const login_func = async () => {
        const postData = {
            'className'    : 'mch.models.masta.User',
            'methodName'   : 'login',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'password'     : password
        }
        await loginPostData(postData);
    };
    
    //===============================================
    // useEffect
    //===============================================
	//-----------------------------------------------
    // useEffect - パスワードチェック
	//-----------------------------------------------
    useEffect(() => {
        if (loginPostResponse) {
            if (loginPostResponse.return == "NG") {
                alert('ユーザIDまたはパスワードが正しくありません');
            } else {
                sessionStorage.setItem('token',loginPostResponse.token);
                sessionStorage.setItem('facilityCode', facilityCode);
                sessionStorage.setItem('facilityName', facilityName);
                sessionStorage.setItem('userId',loginPostResponse.userId);
                sessionStorage.setItem('userName', loginPostResponse.userName);
                sessionStorage.setItem('authority',loginPostResponse.authority);
                sessionStorage.setItem('authorityName',loginPostResponse.authorityName);
                sessionStorage.setItem('traderCode', loginPostResponse.traderCode);
                sessionStorage.setItem('trader',loginPostResponse.trader);
                
                setAuthInfo({
                    isAuthenticated : true,
                    token           : authInfo.token,
                    facilityCode    : facilityCode,
                    facilityName    : facilityName,
                    userId          : loginPostResponse.userId,
                    userName        : loginPostResponse.userName,
                    authority       : loginPostResponse.authority,
                    authorityName   : loginPostResponse.authorityName,
                    traderCode      : loginPostResponse.traderCode,
                    trader          : loginPostResponse.trader,
                })
                // スマホ用のコンポーネントをレンダリング
                navigate('/homeMobile');
            }
        }
    }, [loginPostResponse]);
    
    //===============================================
    // eventHandler
    //===============================================
	//-----------------------------------------------
    // eventHandler - ログインボタンのクリック
	//-----------------------------------------------
    const quasiLogin = async () => {
        if (userId && password) {
            login_func();
        }
        return false
    }
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
        <Header loginInfo="off" backButton="off" backPage="/" />
            <div className='login' style={{overflow:'hidden'}}>
                <Grid container justifyContent="center" alignItems="center" style={{ height: '85vh' }} >
                    <Grid>
                        <div className="login_div_1">SmartG-Expert</div>
                        <div className="login_div_2">電子入札管理システム</div>
                        <div className="login_div_3">Bid Information Management System</div>
                        <div>
                            <CustomOutlinedInput type="text" id="mobileLogins_userId" label="ユーザID" onChange={(e) => setUserId(e.target.value)} style={{ margin: '1rem', width: '20rem', fontSize: '22px' }} />
                        </div>
                        <div>
                            <CustomOutlinedInput type="password" id="mobileLogins_password" label="パスワード" onChange={(e) => setPassword(e.target.value)} style={{ margin: '1rem', width: '20rem', fontSize: '22px' }} />
                        </div>
                        <div>
                            <FormControl className="formcontrol" variant="outlined">
                                <Button
                                    color     = "secondary"
                                    size      = "large"
                                    style     = {{ fontSize: '20px', width: '20rem',margin: '1rem', color:'#fff', backgroundColor: '#305496' }}
                                    variant   = "contained"
                                    startIcon = {<InfoIcon />}
                                    onClick   = {() => { quasiLogin() }}
                                >
                                ログイン
                                </Button>
                            </FormControl>
                        </div>
                        
                    </Grid>
                </Grid>
            </div>
        </>
    )
}
export default Mobile;